import { DeviceBaseV2 } from "types";

import { v2ApiClient } from "../apiClient";

export const getDevice = (tid: string) =>
  v2ApiClient.get<DeviceBaseV2>(`/api/v2/device/${encodeURIComponent(tid)}`, {
    luna_unstable_fields: true
  });
